import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AboveTheFoldOnlyServerRender } from 'above-the-fold-only-server-render';

import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import LoginOverlayContainer from '../LoginOverlayContainer';
import ItemWidget from '../../components/widgets/ItemWidget';
import { currentUserSelector } from '../../selectors/AuthSelector';
import AvailabilityDetailActions from '../../actions/AvailabilityDetailActions';
import WidgetActions from '../../actions/WidgetActions';

class ItemWidgetContainer extends BcReactComponent {
  static fetchInitialData(params, query, store) {
    return [
      store.dispatch(WidgetActions.fetchItem(params.metadataId))
    ];
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentUser !== nextProps.currentUser) {
      this.props.widgetActions.fetchItem(this.props.item.get('id'));
    }
  }

  render() {
    const { item, availabilityDetail, availabilityDetailActions, currentUser } = this.props;
    const skipSSR = this.props.location.query.ssr === '0';
    return (
      <AboveTheFoldOnlyServerRender skip={skipSSR}>
        <div>
          <ItemWidget item={item} availabilityDetail={availabilityDetail} availabilityDetailActions={availabilityDetailActions} currentUser={currentUser} isWidget={this.context.isWidget} />
          <LoginOverlayContainer />
        </div>
      </AboveTheFoldOnlyServerRender>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  item: state.getIn(['entities', 'bibs', ownProps.params.metadataId]),
  availabilityDetail: state.get('availabilityDetail'),
  currentUser: currentUserSelector(state)
});

const mapDispatchToProps = (dispatch) => ({
  availabilityDetailActions: bindActionCreators(AvailabilityDetailActions, dispatch),
  widgetActions: bindActionCreators(WidgetActions, dispatch)
});

ItemWidgetContainer.propTypes = {
  item: ImmutablePropTypes.map,
  availabilityDetail: ImmutablePropTypes.map,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func)
};

ItemWidgetContainer.contextTypes = {
  isWidget: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemWidgetContainer);



// WEBPACK FOOTER //
// ./app/containers/widgets/ItemWidgetContainer.jsx